/**
 * 貨幣代碼說明（繁體中文）：
 * AED: 阿拉伯聯合大公國迪拉姆
 * ARS: 阿根廷披索
 * AUD: 澳大利亞元
 * BDT: 孟加拉塔卡
 * BGN: 保加利亞列弗
 * BHD: 巴林第納爾
 * BMD: 百慕達元
 * BOB: 玻利維亞玻利維亞諾
 * BRL: 巴西雷亞爾
 * BSD: 巴哈馬元
 * BWP: 博茨瓦納普拉
 * BYN: 白俄羅斯盧布
 * CAD: 加拿大元
 * CHF: 瑞士法郎
 * CLP: 智利披索
 * CNY: 人民幣
 * COP: 哥倫比亞披索
 * CRC: 哥斯大黎加科朗
 * CZK: 捷克克朗
 * DKK: 丹麥克朗
 * DZD: 阿爾及利亞第納爾
 * EGP: 埃及鎊
 * EUR: 歐元
 * FJD: 斐濟元
 * GBP: 英鎊
 * GEL: 喬治亞拉里
 * GHS: 迦納塞地
 * GNF: 幾內亞法郎
 * GTQ: 瓜地馬拉格查爾
 * GYD: 蓋亞那元
 * HKD: 港幣
 * HNL: 宏都拉斯倫皮拉
 * HRK: 克羅埃西亞庫納
 * HTG: 海地古德
 * HUF: 匈牙利福林
 * IDR: 印尼盾
 * ILS: 以色列新謝克爾
 * INR: 印度盧比
 * ISK: 冰島克朗
 * JMD: 牙買加元
 * JOD: 約旦第納爾
 * JPY: 日圓
 * KES: 肯亞先令
 * KGS: 吉爾吉斯索姆
 * KHR: 柬埔寨瑞爾
 * KRW: 韓元
 * KWD: 科威特第納爾
 * KYD: 開曼群島元
 * KZT: 哈薩克堅戈
 * LAK: 寮國基普
 * LBP: 黎巴嫩鎊
 * LKR: 斯里蘭卡盧比
 * LSL: 賴索托洛蒂
 * LYD: 利比亞第納爾
 * MAD: 摩洛哥迪拉姆
 * MDL: 摩爾多瓦列伊
 * MKD: 馬其頓第納爾
 * MMK: 緬甸元
 * MNT: 蒙古圖格里克
 * MOP: 澳門元
 * MVR: 馬爾地夫拉菲亞
 * MWK: 馬拉威克瓦查
 * MXN: 墨西哥披索
 * MYR: 馬來西亞令吉
 * MZN: 莫三比克梅蒂卡爾
 * NAD: 納米比亞元
 * NGN: 奈及利亞奈拉
 * NIO: 尼加拉瓜科多巴
 * NOK: 挪威克朗
 * NPR: 尼泊爾盧比
 * NZD: 紐西蘭元
 * OMR: 阿曼里亞爾
 * PEN: 祕魯新索爾
 * PGK: 巴布亞紐幾內亞基那
 * PHP: 菲律賓披索
 * PKR: 巴基斯坦盧比
 * PLN: 波蘭茲羅提
 * PYG: 巴拉圭瓜拉尼
 * QAR: 卡達里亞爾
 * RON: 羅馬尼亞列伊
 * RSD: 塞爾維亞第納爾
 * RUB: 俄羅斯盧布
 * RWF: 盧安達法郎
 * SAR: 沙烏地阿拉伯里亞爾
 * SCR: 塞席爾盧比
 * SDG: 蘇丹鎊
 * SEK: 瑞典克朗
 * SGD: 新加坡元
 * SLL: 塞拉利昂利昂
 * SOS: 索馬利亞先令
 * SRD: 蘇利南元
 * STD: 聖多美和普林西比多布拉
 * SYP: 敘利亞鎊
 * SZL: 史瓦濟蘭里蘭吉尼
 * THB: 泰銖
 * TJS: 塔吉克索莫尼
 * TND: 突尼西亞第納爾
 * TOP: 東加潘加
 * TRY: 土耳其里拉
 * TTD: 千里達及托巴哥元
 * TWD: 新台幣
 * UAH: 烏克蘭格里夫納
 * UGX: 烏干達先令
 * USD: 美元
 * UYU: 烏拉圭披索
 * UZS: 烏茲別克索姆
 * VEF: 委內瑞拉玻利瓦爾
 * VND: 越南盾
 * VUV: 萬那杜瓦圖
 * WST: 薩摩亞塔拉
 * XAF: 中非金融合作法郎
 * XCD: 東加勒比元
 * XOF: 西非法郎
 * XPF: 太平洋法郎
 * ZAR: 南非蘭特
 * ZMW: 尚比亞克瓦查
 * ZWL: 辛巴威元
 *
 */
export const CURRENCY = {
  AED: 'AED',
  AFN: 'AFN',
  ALL: 'ALL',
  AMD: 'AMD',
  ANG: 'ANG',
  AOA: 'AOA',
  ARS: 'ARS',
  AUD: 'AUD',
  AWG: 'AWG',
  AZN: 'AZN',
  BAM: 'BAM',
  BBD: 'BBD',
  BDT: 'BDT',
  BGN: 'BGN',
  BHD: 'BHD',
  BIF: 'BIF',
  BMD: 'BMD',
  BND: 'BND',
  BOB: 'BOB',
  BRL: 'BRL',
  BSD: 'BSD',
  BTN: 'BTN',
  BWP: 'BWP',
  BYN: 'BYN',
  BZD: 'BZD',
  CAD: 'CAD',
  CDF: 'CDF',
  CHF: 'CHF',
  CLP: 'CLP',
  CNY: 'CNY',
  COP: 'COP',
  CRC: 'CRC',
  CUC: 'CUC',
  CUP: 'CUP',
  CVE: 'CVE',
  CZK: 'CZK',
  DJF: 'DJF',
  DKK: 'DKK',
  DOP: 'DOP',
  DZD: 'DZD',
  EGP: 'EGP',
  ERN: 'ERN',
  ETB: 'ETB',
  EUR: 'EUR',
  FJD: 'FJD',
  FKP: 'FKP',
  GBP: 'GBP',
  GEL: 'GEL',
  GHS: 'GHS',
  GIP: 'GIP',
  GMD: 'GMD',
  GNF: 'GNF',
  GTQ: 'GTQ',
  GYD: 'GYD',
  HKD: 'HKD',
  HNL: 'HNL',
  HRK: 'HRK',
  HTG: 'HTG',
  HUF: 'HUF',
  IDR: 'IDR',
  ILS: 'ILS',
  INR: 'INR',
  IQD: 'IQD',
  IRR: 'IRR',
  ISK: 'ISK',
  JMD: 'JMD',
  JOD: 'JOD',
  JPY: 'JPY',
  KES: 'KES',
  KGS: 'KGS',
  KHR: 'KHR',
  KMF: 'KMF',
  KPW: 'KPW',
  KRW: 'KRW',
  KWD: 'KWD',
  KYD: 'KYD',
  KZT: 'KZT',
  LAK: 'LAK',
  LBP: 'LBP',
  LKR: 'LKR',
  LRD: 'LRD',
  LSL: 'LSL',
  LYD: 'LYD',
  MAD: 'MAD',
  MDL: 'MDL',
  MGA: 'MGA',
  MKD: 'MKD',
  MMK: 'MMK',
  MNT: 'MNT',
  MOP: 'MOP',
  MRU: 'MRU',
  MUR: 'MUR',
  MVR: 'MVR',
  MWK: 'MWK',
  MXN: 'MXN',
  MYR: 'MYR',
  MZN: 'MZN',
  NAD: 'NAD',
  NGN: 'NGN',
  NIO: 'NIO',
  NOK: 'NOK',
  NPR: 'NPR',
  NZD: 'NZD',
  OMR: 'OMR',
  PAB: 'PAB',
  PEN: 'PEN',
  PGK: 'PGK',
  PHP: 'PHP',
  PKR: 'PKR',
  PLN: 'PLN',
  PYG: 'PYG',
  QAR: 'QAR',
  RON: 'RON',
  RSD: 'RSD',
  RUB: 'RUB',
  RWF: 'RWF',
  SAR: 'SAR',
  SBD: 'SBD',
  SCR: 'SCR',
  SDG: 'SDG',
  SEK: 'SEK',
  SGD: 'SGD',
  SHP: 'SHP',
  SLE: 'SLE',
  SLL: 'SLL',
  SOS: 'SOS',
  SRD: 'SRD',
  SSP: 'SSP',
  STN: 'STN',
  SVC: 'SVC',
  SYP: 'SYP',
  SZL: 'SZL',
  THB: 'THB',
  TJS: 'TJS',
  TMT: 'TMT',
  TND: 'TND',
  TOP: 'TOP',
  TRY: 'TRY',
  TTD: 'TTD',
  TWD: 'TWD',
  TZS: 'TZS',
  UAH: 'UAH',
  UGX: 'UGX',
  USD: 'USD',
  UYU: 'UYU',
  UZS: 'UZS',
  VES: 'VES',
  VND: 'VND',
  VUV: 'VUV',
  WST: 'WST',
  XAF: 'XAF',
  XCD: 'XCD',
  XCG: 'XCG',
  XDR: 'XDR',
  XOF: 'XOF',
  XPF: 'XPF',
  XSU: 'XSU',
  YER: 'YER',
  ZAR: 'ZAR',
  ZMW: 'ZMW',
  ZWG: 'ZWG',
  ZWL: 'ZWL',
};

export const CURRENCY_SYMBOL = {
  AED: 'د.إ',
  AFN: '؋',
  ALL: 'L',
  AMD: '֏',
  ANG: 'ƒ',
  AOA: 'Kz',
  ARS: '$',
  AUD: '$',
  AWG: 'ƒ',
  AZN: '₼',
  BAM: 'KM',
  BBD: '$',
  BDT: '৳',
  BGN: 'лв',
  BHD: 'ب.د',
  BIF: 'BIF',
  BMD: '$',
  BND: '$',
  BOB: 'Bs.',
  BRL: 'R$',
  BSD: '$',
  BTN: 'BTN',
  BWP: 'P',
  BYN: 'Br',
  BZD: '$',
  CAD: '$',
  CDF: 'FC',
  CHF: 'CHF',
  CLP: '$',
  CNY: '¥',
  COP: '$',
  CRC: '₡',
  CUC: '$',
  CUP: '$',
  CVE: 'CVE',
  CZK: 'Kč',
  DJF: 'Fdj',
  DKK: 'kr',
  DOP: '$',
  DZD: 'دج',
  EGP: '£',
  ERN: 'ERN',
  ETB: 'ETB',
  EUR: '€',
  FJD: '$',
  FKP: '£',
  GBP: '£',
  GEL: '₾',
  GHS: '₵',
  GIP: '£',
  GMD: 'GMD',
  GNF: 'FG',
  GTQ: 'Q',
  GYD: '$',
  HKD: '$',
  HNL: 'L',
  HRK: 'kn',
  HTG: 'G',
  HUF: 'Ft',
  IDR: 'Rp',
  ILS: '₪',
  INR: '₹',
  IQD: 'IQD',
  IRR: 'IRR',
  ISK: 'kr',
  JMD: '$',
  JOD: 'د.ا',
  JPY: '¥',
  KES: 'KSh',
  KGS: 'лв',
  KHR: '៛',
  KMF: 'CF',
  KPW: '₩',
  KRW: '₩',
  KWD: 'د.ك',
  KYD: '$',
  KZT: '₸',
  LAK: '₭',
  LBP: 'ل.ل',
  LKR: '₨',
  LRD: '$',
  LSL: 'L',
  LYD: 'ل.د',
  MAD: 'د.م.',
  MDL: 'L',
  MGA: 'Ar',
  MKD: 'ден',
  MMK: 'K',
  MNT: '₮',
  MOP: 'MOP$',
  MRU: 'MRU',
  MUR: 'Rs',
  MVR: 'Rf',
  MWK: 'MK',
  MXN: '$',
  MYR: 'RM',
  MZN: 'MT',
  NAD: '$',
  NGN: '₦',
  NIO: 'C$',
  NOK: 'kr',
  NPR: '₨',
  NZD: '$',
  OMR: 'ر.ع.',
  PAB: 'PAB',
  PEN: 'S/',
  PGK: 'K',
  PHP: '₱',
  PKR: '₨',
  PLN: 'zł',
  PYG: '₲',
  QAR: 'ر.ق',
  RON: 'lei',
  RSD: 'дин',
  RUB: '₽',
  RWF: 'FRw',
  SAR: 'ر.س',
  SBD: '$',
  SCR: '₨',
  SDG: 'ج.س.',
  SEK: 'kr',
  SGD: '$',
  SHP: '£',
  SLE: 'SLE',
  SLL: 'Le',
  SOS: 'Sh',
  SRD: '$',
  SSP: '£',
  STN: 'Db',
  SVC: 'SVC',
  SYP: '£',
  SZL: 'E',
  THB: '฿',
  TJS: 'ЅM',
  TMT: 'TMT',
  TND: 'د.ت',
  TOP: 'T$',
  TRY: '₺',
  TTD: '$',
  TWD: 'NT$',
  TZS: 'TSh',
  UAH: '₴',
  UGX: 'USh',
  USD: '$',
  UYU: '$U',
  UZS: 'soʻm',
  VES: 'VES',
  VND: '₫',
  VUV: 'VT',
  WST: 'WS$',
  XAF: 'FCFA',
  XCD: '$',
  XCG: 'Cg.',
  XDR: 'XDR',
  XOF: 'CFA',
  XPF: '₣',
  XSU: 'XSU',
  YER: 'YER',
  ZAR: 'R',
  ZMW: 'ZK',
  ZWG: 'ZWG',
  ZWL: '$',
};

export default {CURRENCY, CURRENCY_SYMBOL};
